import React from 'react';
import { ReactComponent as Warning } from '@/assets/images/svg/warning.svg';

export const CancelContent: React.FC = (): JSX.Element => (
  <React.Fragment>
    <div className="exclude-container">
      <Warning color="#E64F49" />
      <div className="header-title-text modal__title">
        <h5 className="modal__confirmation-title">
          Você tem certeza que quer cancelar esse pedido?
        </h5>
      </div>
      <div className="modal__confirmation-text">
        Ao cancelar o pedido, os ingressos ficarão inválidos sem a possibilidade de recuperá-los.
      </div>
    </div>
  </React.Fragment>
);
